import { TextField, Box, Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";
import { Person, FilterList } from "@mui/icons-material";
import React from "react";

export default function ReportSearchBar({ search, onChange, typeFilter, onTypeFilterChange }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} md={8}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search reports by name, ID or details..."
          value={search}
          onChange={(e) => onChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <Box sx={{ mr: 1, opacity: 0.7 }}>
                <Person />
              </Box>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Report Type</InputLabel>
          <Select
            value={typeFilter}
            onChange={(e) => onTypeFilterChange(e.target.value)}
            label="Report Type"
            startAdornment={
              <Box sx={{ ml: 1, mr: 1, opacity: 0.7, display: 'flex', alignItems: 'center' }}>
                <FilterList />
              </Box>
            }
          >
            <MenuItem value="">All Types</MenuItem>
            <MenuItem value="PROFILE">Profile</MenuItem>
            <MenuItem value="MESSAGE">Message</MenuItem>
            <MenuItem value="IMAGE">Image</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
